// In components/SaleReportTempDrawer.js
import React, { useState, useEffect } from 'react';
import { Drawer, Form, Button, Table, InputNumber, message } from 'antd';
import API from '../../api';

const SaleReportTempDrawer = ({ open, setOpen, data, onSave }) => {
  const [form] = Form.useForm();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  // Initialize form and products when drawer opens with sale data
  useEffect(() => {
    if (data && open) {
      const initialProducts = data.products.map(product => ({
        _id: product._id,
        productId: product.productId?._id,
        name: product.productId?.specifications?.name || 'N/A',
        productsPurchasePrice: product.productsPurchasePrice || null,
      }));
      setProducts(initialProducts);
      form.resetFields();
    }
  }, [data, open, form]);

  // Handle productsPurchasePrice change for a specific product
  const handlePurchasePriceChange = (index, value) => {
    const updatedProducts = [...products];
    updatedProducts[index].productsPurchasePrice = value;
    setProducts(updatedProducts);
  };

  // Define table columns for products
  const columns = [
    {
      title: 'Product Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Purchase Price (₹)',
      key: 'productsPurchasePrice',
      render: (_, record, index) => (
        <InputNumber
          min={0}
          value={record.productsPurchasePrice}
          onChange={(value) => handlePurchasePriceChange(index, value)}
          formatter={(value) => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          parser={(value) => value.replace(/₹\s?|(,*)/g, '')}
          style={{ width: '150px' }}
        />
      ),
    },
  ];

  // Handle form submission
  const onFinish = async () => {
    try {
      setLoading(true);
      const payload = {
        products: products.map(product => ({
          _id: product._id,
          productsPurchasePrice: product.productsPurchasePrice,
        })),
      };

      // Send update request to backend
      const response = await API.patch(`/sales/${data._id}/update-purchase-price`, payload);
      
      message.success('Purchase prices updated successfully!');
      setOpen(false);
      form.resetFields();
      setProducts([]);
      onSave(response.data); // Trigger parent refresh
    } catch (error) {
      console.error('Error updating purchase prices:', error);
      message.error(error.response?.data?.message || 'Failed to update purchase prices.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      title={data ? 'Edit Purchase Prices' : 'Sale Details'}
      width={600}
      onClose={() => {
        setOpen(false);
        form.resetFields();
        setProducts([]);
      }}
      open={open}
      bodyStyle={{ paddingBottom: 80 }}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <h3>Products</h3>
        <Table
          columns={columns}
          dataSource={products}
          rowKey="_id"
          pagination={false}
          style={{ marginBottom: 20 }}
        />
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default SaleReportTempDrawer;